module.exports = __webpack_public_path__ + "static/media/success.1644832a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/success.png
// module id = 500
// module chunks = 0